// extracted by mini-css-extract-plugin
export default {"article":"builder_article__1vZAv","main":"builder_main__IKn3T"};